module.exports = __webpack_public_path__ + "img/notodo.01b6b5c0.png";